module.exports = __webpack_public_path__ + "static/media/reward38.9d568437.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/reward38.png
// module id = 209
// module chunks = 0